import { useCareerLayerStore } from '@/shared/stores/careerLayer.store';
import { useCallback } from 'react';

export const useAppCareerLayer = () => {
  const apiData = useCareerLayerStore((state) => state.apiData);
  // const consolidatedData = useCareerLayerStore(
  //   (state) => state.consolidatedData,
  // );
  const specificFilters = useCareerLayerStore((state) => state.specificFilters);
  const valueHeader = useCareerLayerStore((state) => state.valueHeader);
  const isLoading = useCareerLayerStore((state) => state.isLoading);

  const loadData = useCareerLayerStore((state) => state.loadData);
  // const setConsolidatedData = useCareerLayerStore(
  //   (state) => state.setConsolidatedData,
  // );
  const setSpecificFilters = useCareerLayerStore(
    (state) => state.setSpecificFilters,
  );
  const setValueHeader = useCareerLayerStore((state) => state.setValueHeader);
  const setLoading = useCareerLayerStore((state) => state.setLoading);
  const clearData = useCareerLayerStore((state) => state.clearData);

  // const handleSetConsolidatedData = useCallback(
  //   (data: Parameters<typeof setConsolidatedData>[0]) => {
  //     setConsolidatedData(data);
  //   },
  //   [setConsolidatedData],
  // );

  const handleSetSpecificFilters = useCallback(
    (filters: Parameters<typeof setSpecificFilters>[0]) => {
      setSpecificFilters(filters);
    },
    [setSpecificFilters],
  );

  const handleSetValueHeader = useCallback(
    (valueHeader: Parameters<typeof setValueHeader>[0]) => {
      setValueHeader(valueHeader);
    },
    [setValueHeader],
  );

  const handleSetLoading = useCallback(
    (loading: boolean) => {
      setLoading(loading);
    },
    [setLoading],
  );

  const handleClearData = useCallback(() => {
    clearData();
  }, [clearData]);

  return {
    apiData,
    // consolidatedData,
    specificFilters,
    valueHeader,
    isLoading,

    loadData,
    // setConsolidatedData: handleSetConsolidatedData,
    setSpecificFilters: handleSetSpecificFilters,
    setValueHeader: handleSetValueHeader,
    setLoading: handleSetLoading,
    clearData: handleClearData,
  };
};
